import store from "@/store";
export const translate3 = (item, field) => {
  const lang = store.getters["common/language"];
  // console.log(item, field)
  if (item === null || item === undefined) return "";
  if (item.TranslationEffectives === null || item.TranslationEffectives === undefined)
    return item[field] || "";
  const trans = item.TranslationEffectives.filter(
    (o) => o.LanguageCode === lang.language,
  );
  if (trans.length > 0)
    if (Object.keys(trans[0]).indexOf(field) > -1)
      return trans[0][field] || item[field] || "";
  return item[field] || "";
};

